import React from 'react';
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';

const Tooltip = ({ tooltip, divClassName, className, placement, children }) => {
  return (
    <>
      <Tippy
        content={tooltip}
        interactive={true}
        className={className || ''}
        placement={placement || 'bottom'}
      >
        <div className={divClassName} style={{ width: 'fit-content' }}>{children}</div>
      </Tippy>
    </>
  );
};

export default Tooltip;
